"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectFromXYs = void 0;
var rectangle_1 = require("../../types/record/rectangle");
var distance_1 = require("../numeric/distance");
var RectFromXYs = function (xs, ys) {
    return (0, rectangle_1.IRect)({
        top: Math.min(ys[0], ys[1]),
        left: Math.min(xs[0], xs[1]),
        width: (0, distance_1.dist)(xs[0], xs[1]),
        height: (0, distance_1.dist)(ys[0], ys[1])
    });
};
exports.RectFromXYs = RectFromXYs;
